<template>
  <ExternalQueryList
      headline="Layouts"
      endpoint="/api/v2/content-layouts"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentLayout => $router.push(getUrl(contentLayout))"
  >
    <template v-slot:default="{ row: contentLayout }">
      <td>
        <router-link :to="getUrl(contentLayout)">
          {{ contentLayout.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ getLayoutCategory(contentLayout.attributes.layout_category).attributes.name }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/layouts/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'Layout Category'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentLayout) {
      return '/portals/' + this.portal.id + '/content/layouts/' + contentLayout.id + '/edit'
    },

    getLayoutCategory(id) {
      return this.layoutCategories.find(layoutCategory => layoutCategory.id === id)
    }
  }
}
</script>
